module.exports = __webpack_public_path__ + "static/media/win.158d3cea.png";